import React from 'react';
import { TorgaContext } from '../TorgaContext';
import { Browser, List, Page } from '../../utils/Layout/Layout';
import ObjectSelector from '../../utils/ObjectSelector/ObjectSelector';
import { ObjectTypes, urlToTask, urlToTaskID } from '../TorgaRouter';
import Task from './Task';
import { actionTaskCreate } from './actions';
import { useNavigate } from 'react-router-dom';

export default function Routines() {
  const { state, dispatchAction } = React.useContext(TorgaContext);
  const [, setSearch] = React.useState('');
  const navigate = useNavigate();

  const tasks = state.tasks.allIDs.map((id) => state.tasks.byID[id]);

  return (
    <Browser>
      <List>
        <ObjectSelector
          objects={tasks}
          objectType={ObjectTypes.TASKS}
          urlToObject={urlToTaskID}
          onChange={setSearch}
          onCreate={() => {
            dispatchAction(
              actionTaskCreate({ name: 'New Task' }, null, (task) => {
                navigate(urlToTaskID(task.id), { state: { focusName: true } });
              })
            );
          }}
          onSelect={(id) => {
            navigate(urlToTaskID(id));
          }}
        />
      </List>

      <Page>
        <Task />
      </Page>
    </Browser>
  );
}
